import React from 'react';
import PropTypes from 'prop-types';

import { usePlayerProfile } from '../../common/hooks/use-player-profile';
import { getPositionNameByKey } from '../../stats-leaders/utils/positions';
import { getTranslation } from '../../../../../../../common/react/utils/translations';
import { OverviewTableCell } from './OverviewTableCell';
import { OverviewTableRow } from './OverviewTableRow';
import { OverviewTableDraftCell } from './OverviewTableDraftCell';
import { OverviewTableLinkCell } from './OverviewTableLinkCell';

export const OverviewTable = ({ seasonId, playerIds }) => {
    const playerOne = usePlayerProfile(seasonId, playerIds[1]);
    const playerTwo = usePlayerProfile(seasonId, playerIds[2]);

    return (
        <div role="table" className="overview-table">
            <OverviewTableRow>
                <OverviewTableCell
                    value={playerOne?.playerDetails?.position}
                    displayFunction={getPositionNameByKey}
                />
                <div role="rowheader" className="overview-table__header">
                    {getTranslation('label.statsCompare.position')}
                </div>
                <OverviewTableCell
                    value={playerTwo?.playerDetails?.position}
                    displayFunction={getPositionNameByKey}
                />
            </OverviewTableRow>
            <OverviewTableRow>
                <OverviewTableCell value={playerOne?.playerDetails?.age} />
                <div role="rowheader" className="overview-table__header">
                    {getTranslation('label.statsCompare.age')}
                </div>
                <OverviewTableCell value={playerTwo?.playerDetails?.age} />
            </OverviewTableRow>
            <OverviewTableRow>
                <OverviewTableCell
                    value={playerOne?.playerDetails?.heightCm}
                    suffix={'cm'}
                />
                <div role="rowheader" className="overview-table__header">
                    {getTranslation('label.statsCompare.height')}
                </div>
                <OverviewTableCell
                    value={playerTwo?.playerDetails?.heightCm}
                    suffix={'cm'}
                />
            </OverviewTableRow>
            <OverviewTableRow>
                <OverviewTableCell
                    value={playerOne?.playerDetails?.weightKg}
                    suffix={'kg'}
                />
                <div role="rowheader" className="overview-table__header">
                    {getTranslation('label.statsCompare.weight')}
                </div>
                <OverviewTableCell
                    value={playerTwo?.playerDetails?.weightKg}
                    suffix={'kg'}
                />
            </OverviewTableRow>
            <OverviewTableRow>
                <OverviewTableCell
                    value={playerOne?.careerTotals?.matchesPlayed}
                />
                <div role="rowheader" className="overview-table__header">
                    <span className="u-hide-until-tablet">
                        {getTranslation('label.statsCompare.totalGames')}
                    </span>
                    <span className="u-hide-from-tablet">
                        {getTranslation('label.statsCompare.totalGames.short')}
                    </span>
                </div>
                <OverviewTableCell
                    value={playerTwo?.careerTotals?.matchesPlayed}
                />
            </OverviewTableRow>
            <OverviewTableRow>
                <OverviewTableCell
                    value={playerOne?.playerDetails?.debutYear}
                />
                <div role="rowheader" className="overview-table__header">
                    {getTranslation('label.statsCompare.debut')}
                </div>
                <OverviewTableCell
                    value={playerTwo?.playerDetails?.debutYear}
                />
            </OverviewTableRow>
            <OverviewTableRow>
                <OverviewTableDraftCell player={playerOne} />
                <div role="rowheader" className="overview-table__header">
                    {getTranslation('label.statsCompare.draft')}
                </div>
                <OverviewTableDraftCell player={playerTwo} />
            </OverviewTableRow>
            <OverviewTableRow>
                <OverviewTableLinkCell player={playerOne} />
                <OverviewTableLinkCell player={playerTwo} />
            </OverviewTableRow>
        </div>
    );
};

OverviewTable.propTypes = {
    seasonId: PropTypes.string.isRequired,
    playerIds: PropTypes.object.isRequired
};
